/**
 * Comparación monetaria a centavos (misma idea que back/hooks/default/hook_validate_payment.js).
 * Evita falsos positivos por float (p. ej. suma de appliedto ≈ amount pero 4030.0000000002 > 4030).
 */

export function moneyCents(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return 0;
  return Math.round(x * 100);
}

/** true si requested supera limit en centavos (no si son iguales). */
export function exceedsMoneyLimit(requested, limit) {
  return moneyCents(requested) > moneyCents(limit);
}
